import { Button } from "@/components/ui/button";
import { Eraser, RefreshCw, Search } from "lucide-react";
import { GHOST_BUTTON_CLASS } from "../styles";

interface FilterActionsProps {
  isDirty: boolean;
  isLoading: boolean;
  onApply: () => void;
  onClear: () => void;
  onRefresh: () => void;
}

/**
 * Botões de ação dos filtros.
 *
 * A tabela só é recarregada por "Filtrar" ou "Atualizar" - trocar um select
 * apenas monta a seleção, sem consultar a API.
 */
export const FilterActions = ({
  isDirty,
  isLoading,
  onApply,
  onClear,
  onRefresh,
}: FilterActionsProps) => (
  <div className="flex flex-wrap items-center justify-end gap-2">
    <Button
      variant="ghost"
      size="sm"
      className={GHOST_BUTTON_CLASS}
      onClick={onClear}
      disabled={isLoading}
    >
      <Eraser className="mr-2 h-4 w-4" />
      Limpar filtros
    </Button>

    <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading}>
      <RefreshCw className="mr-2 h-4 w-4" />
      Atualizar
    </Button>

    <Button size="sm" onClick={onApply} disabled={isLoading || !isDirty}>
      <Search className="mr-2 h-4 w-4" />
      Filtrar
    </Button>
  </div>
);
